import { cn } from "@/lib/utils"

export function primaryActionClasses(disabled, extra) {
  return cn(
    "rounded-lg px-6 py-3 text-sm font-bold shadow-md transition-all",
    disabled
      ? "cursor-not-allowed border border-border/50 bg-muted text-muted-foreground shadow-none"
      : "bg-primary text-primary-foreground shadow-primary/20 hover:bg-primary/90",
    extra,
  )
}
